import React from "react";

export default function ContactPage() {
  return (
    <div className="contact-page">
      <div className="container">

        <div className="contact-page__layout fade-up">

          {/* LEFT — text + links */}
          <div className="contact-page__left">
            <header className="contact-page__header">
              <p className="contact-page__eyebrow">Get in touch</p>
              <h1 className="contact-page__heading">Let's work<br />together<span style={{ color: "var(--c-teal)" }}>.</span></h1>
            </header>

            <p className="contact-page__intro">
              I'm always open to new collaborations and ideas —
              whether it's data visualisation, a research piece, or an
              interactive storytelling project. If you have something in mind,
              I'd love to hear from you.
            </p>

            <div className="contact-page__links">

              <a href="mailto:airiirisryu@gmail.com" className="contact-page__link-card">
                <div className="contact-page__link-icon">✉</div>
                <div className="contact-page__link-text">
                  <span className="contact-page__link-label">Email</span>
                  <span className="contact-page__link-value">airiirisryu@gmail.com</span>
                </div>
                <span className="contact-page__link-arrow">→</span>
              </a>

              <a
                href="https://www.linkedin.com/in/airi-iris-ryu/"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-page__link-card"
              >
                <div className="contact-page__link-icon">in</div>
                <div className="contact-page__link-text">
                  <span className="contact-page__link-label">LinkedIn</span>
                  <span className="contact-page__link-value">Airi (Iris) Ryu</span>
                </div>
                <span className="contact-page__link-arrow">→</span>
              </a>

            </div>
          </div>

          {/* RIGHT — photo */}
          <div className="contact-page__photo-wrap">
            <img
              src="https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779490497/GhostWoods-0363_a6itgk.jpg"
              alt="slug"
              className="contact-page__photo"
            />
              <p className="contact-page__photo-credit">Photo credit: Crispin Hughes</p>
          </div>

        </div>
      </div>
    </div>
  );
}